import type { MouseEventHandler } from 'react';
import { DeviceCar } from '@/assets/icons/DeviceCar';
import { DeviceMultiple } from '@/assets/icons/DeviceMultiple';
import { IconDropDown } from '@/assets/icons/IconDropdown';
import type { HeadlineChannel } from '@/packages/sxm/sports/channelWaterfall';
import styles from './channelChip.module.scss';

const DEVICE_ICONS = { car: DeviceCar, app: DeviceMultiple };

export interface ChannelChipProps {
    channel: string;
    device?: HeadlineChannel['device'];
    ariaLabel: string;
    ariaExpanded?: boolean;
    ariaControls?: string;
    popoverTarget?: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    dataCy?: string;
}

export function ChannelChip({
    channel,
    device = 'car',
    ariaLabel,
    ariaExpanded,
    ariaControls,
    popoverTarget,
    onClick,
    dataCy,
}: ChannelChipProps) {
    const DeviceIcon = DEVICE_ICONS[device];

    return (
        <button
            type="button"
            className={styles.chip}
            aria-label={ariaLabel}
            aria-expanded={ariaExpanded}
            aria-controls={ariaControls}
            aria-haspopup="dialog"
            popoverTarget={popoverTarget}
            onClick={onClick}
            data-cy={dataCy}
        >
            <span className={styles.label}>
                <span aria-hidden="true">
                    <DeviceIcon className={styles.icon} />
                </span>
                {channel}
            </span>
            <span aria-hidden="true" className={styles.chevron}>
                <IconDropDown className={styles.icon} />
            </span>
        </button>
    );
}
